import { HttpClient, HttpParams } from "@angular/common/http";
import { Inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { BASE_PATH } from "../variables";
import {
  StaffCompanyParameterRequest,
  StaffCompanyParameterResponse,
  StaffLaborRegime,
} from "../model/company-parameter.model";

@Injectable({ providedIn: "root" })
export class StaffCompanyParametersService {
  private readonly url: string;

  constructor(
    private readonly http: HttpClient,
    @Inject(BASE_PATH) organizationBasePath: string,
  ) {
    this.url = `${organizationBasePath.replace(/\/$/, "")}/api/v1/company-parameters`;
  }

  list(filters?: {
    laborRegime?: StaffLaborRegime;
    digitalSignature?: boolean;
  }): Observable<StaffCompanyParameterResponse[]> {
    let params = new HttpParams();
    if (filters?.laborRegime)
      params = params.set("laborRegime", filters.laborRegime);
    if (filters?.digitalSignature != null)
      params = params.set("digitalSignature", filters.digitalSignature);
    return this.http.get<StaffCompanyParameterResponse[]>(this.url, { params });
  }

  getByCompanyId(companyId: number): Observable<StaffCompanyParameterResponse> {
    return this.http.get<StaffCompanyParameterResponse>(
      `${this.url}/company/${companyId}`,
    );
  }

  update(
    companyId: number,
    request: StaffCompanyParameterRequest,
  ): Observable<StaffCompanyParameterResponse> {
    return this.http.put<StaffCompanyParameterResponse>(
      `${this.url}/company/${companyId}`,
      request,
    );
  }
}
